type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'FinancialCategory'
const nameSource = 'financial/categories'
const namePageTitle = 'Categorias financeira'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Categorias financeira',
  to: '/financial/categories',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/categories/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/categories/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/categories/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
